import {createFileRoute} from "@tanstack/react-router";
import {getAllTokenBalances, getPlatformUserDetails} from "./-data";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/adgpt-tokens",
)({
    loader: async ({context}) => {
        const accessToken = context.authenticationStatus.accessToken;
        const [balances, userDetails] = await Promise.all([
            getAllTokenBalances({
                accessToken: accessToken,
                plutoBaseUrl: `${context.intellsysBaseUrl}/sub-system/pluto`,
                queryClient: context.queryClient,
            }),
            getPlatformUserDetails({
                accessToken: accessToken,
                plutoBaseUrl: `${context.intellsysBaseUrl}/sub-system/pluto`,
                queryClient: context.queryClient,
            }),
        ]);

        return {
            accessToken: accessToken,
            balances: balances,
            plutoBaseUrl: `${context.intellsysBaseUrl}/sub-system/pluto`,
            userDetails: userDetails,
            intellsysBaseUrl: context.intellsysBaseUrl,
        };
    },
    component: RouteComponent,
});
